var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    staticClass: "time-form",
    attrs: {
      "disable-sort": "",
      "disable-filtering": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c('v-divider', {
          staticClass: "primary border-2"
        })];
      },
      proxy: true
    }, _vm._l(_vm.headers.filter(function (header) {
      return header.value != 'times';
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var item = _ref.item;
          return [_c('time-form-check', _vm._b({
            key: "".concat(header.value, "-").concat(item.time),
            on: {
              "input": _vm.emit
            },
            model: {
              value: _vm.form,
              callback: function callback($$v) {
                _vm.form = $$v;
              },
              expression: "form"
            }
          }, 'time-form-check', {
            date: header.value,
            time: item.time
          }, false))];
        }
      };
    }), {
      key: "footer",
      fn: function fn() {
        return [_c('v-divider')];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }